import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MenuRequestAddMenuItems, MenuRequestCreate, MenuRequestList, MenuRequestPublish, MenuRequestRemoveMenuItems, MenuRequestSearch, MenuRequestUpdate } from '../../../models/api-store/menu/menu-request.model';
import { MenuResponseAddMenuItems, MenuResponseCreate, MenuResponseGet, MenuResponseList, MenuResponsePublish, MenuResponseRemoveMenuItems, MenuResponseSearch, MenuResponseUpdate } from '../../../models/api-store/menu/menu-response.model';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor(private http: HttpClient) { }
  pathUrl: string = environment.backend.pathUrl.store.menu;
  baseUrl:string = environment.backend.baseUrl_backend;
  url:string = this.baseUrl + this.pathUrl;
  

  /**createParams
   * @param objectStoresParams 
   * @returns params
   * Prende in input un oggetto e lo trasforma in un HttpParams
   */
   createParams(objectStoresParams:any){
    let params = new HttpParams();
    for(let property in objectStoresParams) {
      if(objectStoresParams.hasOwnProperty(property)) {
        params = params.append(property, objectStoresParams[property]);
      }
    }
    return params;
  }

  /**getList
   * @param request 
   * @returns Observable MenuResponseList
   */
  getList(request:MenuRequestList):Observable<MenuResponseList>{
    let url = this.url;
    let params = this.createParams(request);
    return this.http.get<MenuResponseList>(url,{ params: params });
  }

  /**
   * create
   * @param request 
   * @returns Observable MenuResponseCreate
   */
  create(request:MenuRequestCreate):Observable<MenuResponseCreate>{
    let url = this.url+"/";
    return this.http.post<MenuResponseCreate>(url,request);
  }

  /**
   * getEntity
   * @param id 
   * @returns Observable MenuResponseGet
   */
  getEntity(id:number):Observable<MenuResponseGet>{
    let url = this.url+"/"+id;
    return this.http.get<MenuResponseGet>(url);
  }

  /**
   * update
   * @param id 
   * @param request 
   * @returns Observable MenuResponseUpdate
   */
  update(id:number,request:MenuRequestUpdate):Observable<MenuResponseUpdate>{
    let url = this.url+"/"+id;
    return this.http.put<MenuResponseUpdate>(url,request);
  }

  /**
   * delete
   * @param id 
   * @returns 
   */
  delete(id:number){
    let url = this.url+"/"+id;
    return this.http.delete<any>(url);
  }


  /**
   * addMenuItems
   * @param id 
   * @param published 
   * @returns Observable MenuResponseAddMenuItems
   */
   addMenuItems(id:number,idsMenuItems:number[]):Observable<MenuResponseAddMenuItems>{
    let url = this.url+"/"+id+"/addMenuItems"
    let request = new MenuRequestAddMenuItems();
    request.id = id;
    request.idsMenuItems = idsMenuItems;
    return this.http.put<MenuResponseAddMenuItems>(url,request);
  }


  /**
   * publish
   * @param id 
   * @param published 
   * @returns Observable MenuResponsePublish
   */
  publish(id:number,published:boolean):Observable<MenuResponsePublish>{
    let url = this.url+"/"+id+"/publish?published="+published;
    let request = new MenuRequestPublish();
    request.id = id;
    request.published = published;
    return this.http.put<MenuResponsePublish>(url,request);
  }

  /**
   * removeMenuItems
   * @param id 
   * @param published 
   * @returns Observable MenuResponseAddMenuItems
   */
   removeMenuItems(id:number,idsMenuItems:number[]):Observable<MenuResponseRemoveMenuItems>{
    let url = this.url+"/"+id+"/addMenuItems"
    let request = new MenuRequestRemoveMenuItems();
    request.id = id;
    request.idsMenuItems = idsMenuItems;
    return this.http.put<MenuResponseRemoveMenuItems>(url,request);
  }

  /**search
     * 
     * @param request 
     * @returns Observable MenuResponseSearch
     */
   search(request:MenuRequestSearch):Observable<MenuResponseSearch>{
    let url = this.url+"/search";
    return this.http.post<MenuResponseSearch>(url,request);
  }
}
